export const getIsMobile = () => {
  return window.innerWidth < 992;
};
